// #743/#744 Özelleştirilmiş alan "Listeden Seçim" (DataType=5) seçenekleri.
//
// Depolama: ProductAdditionalField.Options / CustomerAdditionalField.Options (JSON string).
//   YENİ format: [{ code, description }] — her seçeneğin kodu + açıklaması var. Seçilen DEĞER = code.
//   ESKİ format (geriye-uyum): ["Mini","Orta"] düz string dizisi → { code: s, description: s }.
//
// Bu iki fonksiyon tek doğruluk kaynağıdır; tanım ekranları, ürün/müşteri master Ek Bilgiler
// seçicileri ve Ürün Rotalama (#734) kriteri hepsi bunları kullanır.

/** Options JSON'unu [{code, description}] listesine çözer (her iki formatı da destekler). */
export function parseFieldOptions(raw) {
  if (!raw) return [];
  let arr;
  try { arr = JSON.parse(raw); } catch { return []; }
  if (!Array.isArray(arr)) return [];
  return arr
    .map((it) => {
      if (it && typeof it === 'object') {
        const code = String(it.code ?? it.Code ?? '').trim();
        const description = String(it.description ?? it.Description ?? '').trim();
        return { code: code || description, description: description || code };
      }
      const s = String(it ?? '').trim();
      return { code: s, description: s };
    })
    .filter((o) => o.code || o.description);
}

/** [{code, description}] listesini Options JSON'una (yeni format) serileştirir; boş kodlular atılır. */
export function serializeFieldOptions(options) {
  return JSON.stringify(
    (options || [])
      .map((o) => ({ code: String(o.code ?? '').trim(), description: String(o.description ?? '').trim() }))
      .filter((o) => o.code),
  );
}

/** Master seçicide gösterilecek etiket: "KOD - Açıklama" (kod=açıklama ise yalnız açıklama). */
export function fieldOptionLabel(o) {
  if (!o) return '';
  if (o.code && o.description && o.code !== o.description) return `${o.code} - ${o.description}`;
  return o.description || o.code || '';
}
